<section class="bread-block">
  <div class="container">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [routerLink]="['']">Головна</a></li>
        <li class="breadcrumb-item"><a [routerLink]="['/portfolio']">Портфоліо</a></li>
        <li class="breadcrumb-item">Студійні та робочі приміщення ЗАТ «ММЦ-СТБ»</li>
      </ol>
    </nav>
  </div>
</section>

<section class="content-page my-2 my-lg-4">
  <div class="container">
    <div class="title title-zag-block">СТУДІЙНІ ТА РОБОЧІ ПРИМІЩЕННЯ ЗАТ «ММЦ-СТБ»</div>
  </div>
</section>

<section class="slider">
  <div class="container">
    <div class="portfolio-owl owl-carousel owl-theme">
      <div class="slider-item">
        <img src="../../../../assets/images/ctb.jpg" alt="Помещения фармацевтического концерна «Стирол»"
             class="img-fluid">
      </div>
    </div>
  </div>
</section>
<section class="content-page my-2 my-lg-4">
  <div class="container">
    <p>Студійні та робочі приміщення ЗАТ «ММЦ-СТБ» - лише понад 7 тис. м2.</p>
  </div>
</section>
<section class="content-page my-2 my-lg-4">
  <div class="container">
    <div class="title title-zag-block">Проведені роботи</div>
    <ol>
      <li>Монтаж напівпромислових та промислових систем кондиціювання та вентиляції повітря Daikin (Японія),
        Mitsubishi Electric (Японія), Panasonic (Малайзія), System
        Air (Швеція), Salda (Литва)
      </li>
    </ol>
  </div>
</section>

<app-our-advantages></app-our-advantages>
<app-our-clients-small></app-our-clients-small>
<app-feedback></app-feedback>
<app-map></app-map>
